import { H4, Image, P } from '../../AbstractElements';
import { Href } from '../../Constant';
import { dynamicImage } from '../../Service/DynamicImage';

const HeaderProfile = () => {
  return (
    <div className="d-flex">
      <div className="media-size-email">
        <Image className= 'me-3 rounded-circle' src= {dynamicImage("user/user.png")} alt= "Image"  />
      </div>
      <div className="flex-grow-1">
        <H4 className='f-w-600' ><a href={Href}>MARK JENCO</a></H4>
        <P>Markjecno@gmail.com</P>
      </div>
    </div>
  );
};

export default HeaderProfile;